// Module
var code = "<molecule-panel-wizard panel-title=\"{{ 'TR_030620-b2f3ef_TR' | translate }}\" modifier=\"restrict-content\"> <panel-body> <div ng-bind-html=\"'TR_030620-84fa99_TR' | translate\"></div> </panel-body> </molecule-panel-wizard> ";
// Exports
module.exports = code;